import { render, staticRenderFns } from "./exhibition-group-toggle.vue?vue&type=template&id=89ac495c&"
import script from "./exhibition-group-toggle.vue?vue&type=script&lang=js&"
export * from "./exhibition-group-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports